import { createFieldControl } from './createFieldControl.ts';
import { GAP_SCALE, TYPE_LEADING } from './tokens.ts';

export const selectTriggerVariants = createFieldControl(
  `flex items-center justify-between ${GAP_SCALE.sm} font-medium [&>span]:break-words [&>span]:${TYPE_LEADING.snug} data-[placeholder]:text-muted-foreground`
);
